import {Component, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {GetPreorders} from '../../../state/actions/appState.preorders.actions';
import {AppState} from '../../../state/appState';
import {Observable} from 'rxjs';
import {PaginatedResponseModel} from '../../../shared/models/paginated.response.model';
import {PreorderListModel} from '../../../shared/services/preorder/preorderList.model';
import {OpenModalPreorderDetail} from '../../../state/actions/appState.modals.actions';
import {PreorderStatus} from '../../../shared/services/preorder/preorderStatus.enum';
import {take, tap} from 'rxjs/operators';
import {Debounce} from 'lodash-decorators';

@Component({
  selector: 'app-preorder',
  templateUrl: './preorder.component.html',
  styleUrls: ['./preorder.component.scss']
})
export class PreorderComponent implements OnInit {
  @Select(AppState.preorders$) preorders$: Observable<PaginatedResponseModel<PreorderListModel>>;
  preorderStatusEnum = Object.values(PreorderStatus);
  preorderStatus: PreorderStatus = null;

  private referenceFilter = '';

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.store.dispatch(new GetPreorders());
  }

  onOpenDetails(reference: string) {
    this.store.dispatch(new OpenModalPreorderDetail(reference));
  }

  onPageSelected(page: number) {
    this.preorders$.pipe(
      take(1),
      tap(paycards => {
        this.getPreorders(page, paycards.size, this.referenceFilter, this.preorderStatus);
      })
    ).subscribe();
  }

  onSizeSelected(size: number) {
    this.preorders$.pipe(
      take(1),
      tap(paycards => {
        this.getPreorders(paycards.number, size, this.referenceFilter, this.preorderStatus);
      })
    ).subscribe();
  }

  @Debounce(1000)
  onReferenceFilterChange(reference: string) {
    this.referenceFilter = reference;
    this.preorders$.pipe(
      take(1),
      tap(paycards => {
        this.getPreorders(paycards.number, paycards.size, this.referenceFilter, this.preorderStatus);
      })
    ).subscribe();
  }

  onPreorderStatusChange(status: PreorderStatus) {
    this.preorderStatus = status;
    this.preorders$.pipe(
      take(1),
      tap(paycards => {
        this.getPreorders(paycards.number, paycards.size, this.referenceFilter, this.preorderStatus);
      })
    ).subscribe();
  }

  private getPreorders(page: number, size: number, reference: string, status: PreorderStatus) {
    this.store.dispatch(new GetPreorders(page, size, reference, status));
  }
}
